const normalTime = (time) => {
  if (time) {
    var odate = new Date();
    odate.setTime(time);
    var year = odate.getFullYear();
    var month = odate.getMonth() + 1;
    var day = odate.getDate();
    var hours = odate.getHours();
    var minutes = odate.getMinutes();
    var seconds = odate.getSeconds();
    return (
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds
    );
  }
};
//key匹配list中的关键字, list需要匹配的数组, type：存在则需要返回为空的文字，不存在就不返回
const setName = (key, list, type) => {
  if (key == undefined) {
    return;
  }
  let label;
  let newArr = list.filter((item) => item.value == key);
  if (newArr.length > 0) {
    label = newArr[0].label;
  } else {
    if (type) {
      label = "暂无" + type;
    }
  }
  return label;
};

//key匹配list中的关键字, list需要匹配的数组, type：存在则需要返回为空的文字，不存在就不返回 只返回前两个字符
const cutName = (key, list, type) => {
  let label;
  let newArr = list.filter((item) => item.value == key);
  if (newArr.length > 0) {
    label = newArr[0].label;
  } else {
    if (type) {
      label = "暂无" + type;
    }
  }
  return label.substring(0, 2);
};

//key匹配list中的关键字, list需要匹配的数组, type：存在则需要返回为空的文字，不存在就不返回
const setIdName = (key, list, type) => {
  let label;
  let newArr = list.filter((item) => item.id == key);
  if (newArr.length > 0) {
    label = newArr[0].name;
  } else {
    if (type) {
      label = "暂无" + type;
    }
  }
  return label;
};

const setTitle = (key, list) => {
  let label;
  let newArr = list.filter((item) => item.type == key);
  if (newArr.length > 0) {
    label = newArr[0].name;
  }
  return label;
};

const setNumber = (val) => {
  if (!val) {
    return "0.00 %";
  }
  let number = (val * 100).toFixed(2);
  return number + " %";
};
export default {
  normalTime,
  setName,
  setTitle,
  setNumber,
  cutName,
  setIdName,
};
